<div
  class="landing-page-button-container"
  [ngClass]="type"
  (click)="onButtonClick()"
  (keyup)="onButtonClick()"
  tabindex="0"
>
  {{ label }}
  @if (sub) {
    <div class="button-sub">{{ sub }}</div>
  }
</div>
